


export default [
    {
        path: '/login',
        component: () => import("../../../views/pages/auth/login.vue"),
      },  
  
]